import 'css-chunk:src/Footer.module.scss';export default {
  "footer": "_footer_1qnf0_1",
  "exportIcsButton": "_exportIcsButton_1qnf0_9",
  "exportIcsImg": "_exportIcsImg_1qnf0_13",
  "githubWrapper": "_githubWrapper_1qnf0_18",
  "githubText": "_githubText_1qnf0_25",
  "githubLogo": "_githubLogo_1qnf0_34"
};